/** @jsx jsx */
import { useContext } from "react"
import { jsx, useThemeUI } from "theme-ui"
import { PropTypes } from "prop-types"
import { TransformLinkUri } from "./link"

import Markdown from "react-markdown"
import ModeContext from "../context/mode-context"

const Services = ({ type, catalogName, serviceItems = [], mode }) => {
    const { mode: globalMode } = useContext(ModeContext)
    const { rawColors: colors } = useThemeUI().theme
    const modeKey = mode ? mode : globalMode
    const modeColor = colors.modes[modeKey]?.primary ?? colors.modes["group"].primary

    return (
        <section>
            {type && <h4>{type}</h4>}
            <div>
                {serviceItems.map((service, i) => (
                    <div key={service._uid}>
                            <div>{service.name}</div>
                            <div>
                                <Markdown urlTransform={(uri) => TransformLinkUri(uri)}>{service.description}</Markdown>
                            </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

Services.propTypes = {
    type: PropTypes.string,
    catalogName: PropTypes.string,
    services: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
        })
    ),
    mode: PropTypes.string, 
}

export default Services